import { useCallback } from 'react';

//* Hoc's
import { withFavoriteContext } from '@/context';
import { useCart } from '@weareconceptstudio/cart';

//* Components
import Price from '../Price';
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import Image from '@/components/common/Image';
import Button from '@/components/common/Button';
import CustomRate from '@/components/common/CustomRate';
import CustomLink from '@/components/common/CustomLink';
import ProductBadges from '@/components/common/ProductBadges';

//* Style
import ShopItemStyle from './style';

const ShopItem = ({ id, image, name, category, url, price, sale_price, discount, average_rating, toggleFavorite, checkActiveFavorite, review_count, stock_status, badges, out_of_stock_message, promotion_message, gift_message, required_qty_for_gift }) => {
	const { toggleCartItem, items } = useCart();
	const isInCart = items.some((item) => Number(item?.product?.id) === Number(id));

	//! Add to bag — keep separate from product navigation
	const handleAddToBag = useCallback(
		(e) => {
			e.preventDefault();
			e.stopPropagation();
			if (isInCart) return Promise.resolve();

			return toggleCartItem({ productId: id, qty: 1 });
		},
		[id, toggleCartItem, isInCart]
	);

	const handleFavoriteClick = useCallback(
		(e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleFavorite({ productId: id });
		},
		[id, toggleFavorite]
	);

	if (!url) {
		return null;
	}

	return (
		<ShopItemStyle>
			<CustomLink
				url={url}
				ariaLabel={name}
				className={'product-item-link'}
			>
				<div className='product-upper'>
					<ProductBadges
						badges={badges}
						className='product-badges'
					/>
					<Image
						src={image?.src}
						alt={image?.alt || name}
						className={'upper-image'}
					/>
				</div>

				<div className='product-lower'>
					<div>
						<Text className={'p font-futura-regular'}>{category}</Text>

						<Text className={'h5 font-futura-medium name'}>{name}</Text>
					</div>

					<div>
						<CustomRate
							value={average_rating}
							className={'product-rate'}
							qty={review_count}
						/>
						{promotion_message || (required_qty_for_gift > 0 && gift_message) ? (
							<p className='h5 feature font-futura-semibold darkGrey promotion-line'>
								{promotion_message || (required_qty_for_gift > 0 ? gift_message || `Buy ${required_qty_for_gift} get a gift` : '')}
							</p>
						) : null}
						<div className='price-wrap'>
							<Price
								price={price}
								sale_price={sale_price}
								discount={discount}
							/>

							{stock_status == 'instock' ? (
								<Button
									hasAdd
									inCart={isInCart}
									size={'small'}
									text={'addToBag'}
									className={'product-card-action'}
									onClick={handleAddToBag}
								/>
							) : (
								<Button
									size={'small'}
									btnType={'out-of-stock'}
									text={'outOfStock'}
									className={`out-of-stock product-card-action`}
									tooltipText={out_of_stock_message}
								/>
							)}
						</div>
					</div>
				</div>
			</CustomLink>

			<Icon
				className={'h2 favorite'}
				onClick={handleFavoriteClick}
				name={`${checkActiveFavorite({ productId: id }) ? 'heart-fill' : 'heart'}`}
			>
				<span className='path1'></span>
				<span className='path2'></span>
			</Icon>
		</ShopItemStyle>
	);
};

export default withFavoriteContext(ShopItem, ['toggleFavorite', 'checkActiveFavorite']);
